import { action, extendObservable } from 'mobx';
import FetchService from '../../../../core/services/FetchService';

export default class CustomerSuccessDetailService {
  fetchSegment = new FetchService();
  fetchDistributor = new FetchService();
  fetchCompany = new FetchService();

  constructor() {
    extendObservable(this, {
      segment: null,
      distributor: null,
      company: null,
    });
  }

  loadSegment = action((id) => {
    this.fetchSegment.fetch({
      url: `/segments/${id}`,
    }).then(() => {
      if (this.fetchSegment.data) {
        this.segment = this.fetchSegment.data;
      } else {
        this.segment = null;
      }
    });
  });

  loadDistributor = action((id) => {
    this.fetchDistributor.fetch({
      url: `/distributors/${id}`,
    }).then(() => {
      if (this.fetchDistributor.data) {
        this.distributor = this.fetchDistributor.data;
      } else {
        this.distributor = null;
      }
    });
  });

  loadCompany = action((id) => {
    this.fetchCompany.fetch({
      url: `/companies/${id}`,
    }).then(() => {
      if (this.fetchCompany.data) {
        this.company = this.fetchCompany.data;
      } else {
        this.company = null;
      }
    });
  });
}